<app-vehicle-banners class="banner-container"></app-vehicle-banners>

<div class="row mb-5">
    <div class="col-md-10 col-xl-12 card-vehicles-availables">
        <div class="main-search-row">
            <div class="left-side">
                <span class="vehicle-type">Tipo de veículo</span>
                <div class="segment-chips">
                    @if (activeSegments.length > 1) {
                        <div class="segment-chip" 
                             [ngClass]="{'selected': selectedSegment === 'ALL'}"
                             (click)="selectSegment('ALL')">
                            <i class="fa-solid fa-car"></i>
                            <span>Todos</span>
                            @if (selectedSegment === 'ALL') {
                                <i class="fa-solid fa-check-circle check-icon"></i>
                            }
                        </div>
                    }

                    @for (seg of segmentConfig; track seg.value) {
                        @if (activeSegments.includes(seg.value)) {
                            <div class="segment-chip" 
                                 [ngClass]="{'selected': selectedSegment === seg.value}"
                                 (click)="selectSegment($any(seg.value))">
                                <i [class]="seg.icon"></i>
                                <span>{{ seg.label }}</span>
                                @if (selectedSegment === seg.value) {
                                    <i class="fa-solid fa-check-circle check-icon"></i>
                                }
                            </div>
                        }
                    }
                </div>
            </div>

            <div class="right-side">
                <div class="saved-filter-label">
                    <i class="fa-solid fa-bookmark"></i>
                    <span>Busca salva</span>
                </div>
                <mat-form-field class="saved-filter-select" appearance="fill">
                    <mat-select [disabled]="!savedFilters" 
                                (selectionChange)="submitFilter($event.value)" 
                                placeholder="Selecionar">
                        <mat-option *ngFor="let savedFilter of savedFilters" [value]="savedFilter.filter">
                            {{savedFilter.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="search-input-row">
            <div class="search-wrapper">
                <div class="search-input-container">
                    <i class="fa-solid fa-search search-icon"></i>
                    <input type="text" 
                           class="search-input" 
                           placeholder="Digite uma marca ou modelo" 
                           [(ngModel)]="searchText"
                           (input)="onSearchTextChange()" 
                           (focus)="onInputFocus()" />
                </div>

                @if (showDropdown && filteredMakeModels.length) {
                    <div class="autocomplete-dropdown">
                        @for (group of filteredMakeModels; track group.id) {
                            <div class="group">
                                <div class="group-title" (click)="selectMake(group.id)">
                                    {{ group.name }}
                                </div>
                                @for (model of group.models; track model.id) {
                                    <div class="option" (click)="selectModel(model.id)">
                                        {{ model.name }}
                                    </div>
                                }
                            </div>
                        }
                    </div>
                }
            </div>

            <button class="btn btn-primary btn-rounded text-white" (click)="submitFilter(filter)">
                VER TODAS AS OFERTAS {{totalElements ? '(' + totalElements + ')' : ''}}
            </button>
        </div>
    </div>
</div>

<app-purchase-profile-banner></app-purchase-profile-banner>

<app-shelf *ngFor="let shelf of shelves" [shelf]="shelf" 
(submitVehicleFilter)="submitFilter($event)" (submitFastQuoteFilter)="submitFilter($event, true)">
</app-shelf>

<div class="col-md-12 text-center" style="margin-top: 80px;">
    <button class="btn btn-primary btn-rounded text-white see-all-offers" (click)="submitFilter(filter)">
        VER TODAS AS OFERTAS {{totalElements ? '(' + totalElements + ')' : ''}}
    </button>
</div>